var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");
name.ocker_first_name = require("./ocker_first_name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/name/index.js
// module id = 1563
// module chunks = 0